var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLearning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "22px",
    viewBox: "0 0 34 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6800F957-6C97-4190-8CA9-E2BED4ED743B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "10.0-Dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "10.0-Dealer-Support-Dashboard",
    transform: "translate(-23.000000, -176.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nav-main",
    transform: "translate(0.000000, 95.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu-Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sidenav/menu",
    transform: "translate(0.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stacked-Group",
    transform: "translate(16.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_48/dummy-icon_48/learning"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-48"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "area",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1515,25.8556 L10.3365,20.1606 L24.2195,14.3986 L37.9675,20.0596 L24.1515,25.8556 Z M33.7215,29.5956 C33.5195,29.8316 33.1155,30.2366 32.4745,30.6746 L32.4415,23.8676 L32.6435,23.7666 L33.7215,23.2946 L33.7215,29.5956 Z M23.9165,32.7296 C17.7155,32.3926 15.3905,30.3376 14.8845,29.7646 L14.8175,23.4626 L23.8815,27.2036 C23.9495,27.2366 24.0505,27.2706 24.1515,27.2706 C24.2535,27.2706 24.3205,27.2366 24.4225,27.2036 L31.1275,24.4066 L31.1945,31.4496 C29.5775,32.2576 27.2185,32.8986 23.9165,32.7296 L23.9165,32.7296 Z M10.5385,27.4736 C10.5385,28.0796 10.0665,28.5516 9.4605,28.5516 C8.8535,28.5516 8.3815,28.0796 8.3815,27.4736 C8.3815,26.8666 8.8535,26.3946 9.4605,26.3946 C10.0665,26.3946 10.5385,26.8996 10.5385,27.4736 L10.5385,27.4736 Z M39.9895,19.4536 L24.4895,13.0506 C24.3205,12.9826 24.1515,12.9826 23.9835,13.0506 L8.7865,19.3186 C8.7525,19.3186 8.7185,19.3526 8.7185,19.3526 L8.2805,19.5876 C8.0455,19.7226 7.9105,19.9586 7.9435,20.2286 C7.9435,20.4976 8.1125,20.6996 8.3475,20.8006 L8.7865,20.9696 L8.7865,25.1146 C7.7755,25.3836 7.0005,26.3276 7.0005,27.4396 C7.0005,28.7876 8.0785,29.8656 9.4255,29.8656 C10.7745,29.8656 11.8525,28.7876 11.8525,27.4396 C11.8525,26.3606 11.1115,25.4176 10.1335,25.1146 L10.1335,21.5756 L13.4365,22.9236 L13.5045,30.0336 C13.5045,30.1686 13.5375,30.3036 13.6045,30.4046 C13.7065,30.5396 15.8965,33.6736 23.8145,34.0776 C24.1855,34.1116 24.5565,34.1116 24.9265,34.1116 C32.0375,34.1116 34.8345,30.3716 34.9345,30.2026 C35.0025,30.1016 35.0695,29.9326 35.0695,29.7976 L35.0695,22.7216 L39.9565,20.6666 C40.1915,20.5646 40.3605,20.3296 40.3605,20.0256 C40.3605,19.7226 40.2255,19.5546 39.9895,19.4536 L39.9895,19.4536 Z",
    id: "Fill-1",
    fill: "#3F3F3F"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearning);
export default __webpack_public_path__ + "static/media/learning.289dfa2edd889a75276c3a7843686bbb.svg";
export { ForwardRef as ReactComponent };